import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('angle-input', {
  root: {
    states: ['disabled'],
  },
  track: {},
  arm: {},
  knobWrapper: {},
  knob: {},
  input: {},
});
